import { Switch } from 'react-router-dom'
import Route from './Route'

import Login from '../pages/Login'
import Dashboard from '../pages/Dashboard'
import NewPatient from '../pages/NewPatient'
import Patients from '../pages/Patients'
import NewTreatment from '../pages/NewTreatment'
import Treatments from '../pages/Treatments'
import NewExam from '../pages/NewExam'
import Exams from '../pages/Exams'
import TypeExam from '../pages/AddTypeExam'

const Routes = () => {
    return (
        <Switch>
            <Route exact path="/" component={Login} />
            <Route exact path="/dashboard" isPrivate component={Dashboard} />
            <Route exact path="/patients/new" isPrivate component={NewPatient} />
            <Route exact path="/patients/edit/:id" isPrivate component={NewPatient} />
            <Route exact path="/patients" isPrivate component={Patients} />
            <Route exact path="/treatments/new" isPrivate component={NewTreatment} />
            <Route exact path="/treatments/edit/:id" isPrivate component={NewTreatment} />
            <Route exact path="/treatments" isPrivate component={Treatments} />
            <Route exact path="/exams/new" isPrivate component={NewExam} />
            <Route exact path="/exams/edit/:id" isPrivate component={NewExam} />
            <Route exact path="/exams" isPrivate component={Exams} />
            <Route exact path="/addexams" isPrivate component={TypeExam} />
            <Route exact path="/addexams/edit/:id" isPrivate component={TypeExam} />
        </Switch>
    )
}

export default Routes
